export default __webpack_public_path__ + "static/media/commodities.8b7aaa94.svg";